// What a key, a name and a value may be: the same rules in the browser (forms, the import's preview) and on the server.

// A variable's key, as a shell and every platform accept it: letters, digits and _, not starting with a digit.
export const KEY_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;
export const KEY_MAX = 128;
// A value fits a certificate chain or a service account's JSON.
export const VALUE_MAX_BYTES = 64 * 1024;
export const NOTE_MAX = 500;
export const NAME_MAX = 60;
export const DESCRIPTION_MAX = 200;
// A pasted .env, at most.
export const IMPORT_MAX_BYTES = 512 * 1024;
export const PASSWORD_MIN = 12;

export const isValidKey = (key: string): boolean => key.length <= KEY_MAX && KEY_PATTERN.test(key);

// An address segment: lowercase letters, digits and dashes, as in /staging/backend.
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

// The web app's own pages live at the first segment, beside the environments.
export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
    'activity',
    'api',
    'assets',
    'compare',
    'environments',
    'fonts',
    'health',
    'login',
    'settings',
    'team',
]);

export function slugify(name: string): string {
    return name
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40)
        .replace(/-+$/g, '');
}

export const COLOR_PATTERN = /^#[0-9a-f]{6}$/;

// The colours an environment can take: fleequid-logs' for the environments both know, then a few more.
export const ENVIRONMENT_COLORS: readonly string[] = ['#e5484d', '#fab219', '#2bc48c', '#3987e5', '#9085e9', '#e26ab5', '#8497b8'];

// The usual environments, made in one go on a new vault; production asks before every change.
export const DEFAULT_ENVIRONMENTS: ReadonlyArray<{ slug: string; name: string; color: string; protected: boolean }> = [
    { slug: 'production', name: 'Production', color: '#e5484d', protected: true },
    { slug: 'preproduction', name: 'Preproduction', color: '#9085e9', protected: false },
    { slug: 'demo', name: 'Demo', color: '#2bc48c', protected: false },
    { slug: 'staging', name: 'Staging', color: '#fab219', protected: false },
    { slug: 'development', name: 'Development', color: '#8497b8', protected: false },
];

// Offered when a new section is named, after the names other environments already use.
export const SECTION_SUGGESTIONS: readonly string[] = ['Backend', 'Frontend', 'Cron', 'Media'];
